import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #F7F8F9;
  display: flex;
  color: #1E2228;
  & input {
    font-size: 14px;
  }
`;
export const ColumnDiv = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`;
export const ContentWrapDiv = styled.div`
  height: calc(100vh - 80px);
  overflow-x: scroll;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
`;
export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HeaderWrapDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 25px 36px;
  & > div {
    font-size: 24px;
    font-weight: 700;
  }
  & > button {
    background-color: #1B49EA;
    color: #ffffff;
    border-radius: 8px;
    padding: 12px 17px;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    & > div {
      height: 15px;
      overflow: hidden;
      margin-right: 8px;
      font-size: 20px;
      display: flex;
      align-items: center;
    }
  }
`;
export const CardDiv = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  margin: 0px 36px auto 36px;
`;
export const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 30px;
  margin-top: 12px;
  & input {
    width: 600px;
    height: 48px;
    border: 1px solid ${props => props.error ? '#E74C3C' : '#c9c9c9'};
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & select {
    width: 600px;
    height: 55px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & textarea {
    width: 600px;
    border: 1px solid #c9c9c9;
    padding: 13px 15px;
    font-family: sans-serif;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;
export const InputTitleDiv = styled.div`
  font-size: 14px;
  font-weight: normal;
  margin-bottom: 10px;
`;
export const InputErrorDiv = styled.div`
  height: 18px;
  font-size: 12px;
  color: #E74C3C;
  padding-top: 2px;
`;
export const InputNewButton = styled.button`
  height: 55px;
  width: 55px;
  background-color: #ffffff;
  border: 1px solid #1B49EA;
  border-radius: 8px;
  color: #1B49EA;
  font-size: 26px;
  margin-left: 14px;
  &:hover {
    color: #ffffff;
    background-color: #1B49EA;
  }
`;
export const GreyBoxDiv = styled.div`
  background-color: #F7F8F9;
  border-radius: 10px;
  padding: 30px;
  margin: 8px 30px 30px 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  & input {
    height: 57px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & textarea {
    padding: 12px;
    font-family: sans-serif;
    line-height: 18px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;
export const OptionRowDiv = styled.div`
  display: flex;
  & button {
    height: 57px;
    width: 57px;
    border: 1px solid #c9c9c9;
    margin-left: 23px;
    background: #FFFFFF;
    border-radius: 6px;
  }
`;
export const HeadingDiv = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
`;
export const CheckboxDiv = styled.div`
  height: 57px;
  width: 79px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 4px 38px 4px 18px;
  margin-right: 23px;
  cursor: pointer;
  font-size: 16px;
  user-select: none;
  text-align: left;
  color: #1D252D;
  background-color: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  box-sizing: border-box;
  &:before {
    content: '';
    height: 16px;
    width: 16px;
    position: absolute;
    right: 17px;
    background-color: ${props => props.active ? '#1B49EA' : '#ffffff'};
    border-radius: 50%;
    border: 1px solid ${props => props.active ? '#1B49EA' : '#CCCCCC'};
  }
  &:hover {
    &:before {
      background-color: ${props => props.active ? '#1B49EA' : '#dcdcdc'};
    }
  }
  &:after {
    content: '';
    display: ${props => props.active ? 'block' : 'none'};
    height: 6px;
    width: 3px;
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    position: absolute;
    right: 24px;
    margin-bottom: 1px;
    transform: rotate(45deg);
  }
`;
export const CheckboxDiv2 = styled.div`
  height: 57px;
  width: 108px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 4px 10px 4px 40px;
  margin-right: 23px;
  cursor: pointer;
  font-size: 16px;
  user-select: none;
  text-align: left;
  color: #1D252D;
  background-color: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  box-sizing: border-box;
  &:before {
    content: '';
    height: 16px;
    width: 16px;
    position: absolute;
    left: 14px;
    background-color: ${props => props.active ? '#1B49EA' : '#ffffff'};
    border-radius: 50%;
    border: 1px solid ${props => props.active ? '#1B49EA' : '#CCCCCC'};
  }
  &:hover {
    &:before {
      background-color: ${props => props.active ? '#1B49EA' : '#dcdcdc'};
    }
  }
  &:after {
    content: '';
    display: ${props => props.active ? 'block' : 'none'};
    height: 6px;
    width: 3px;
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    position: absolute;
    left: 21px;
    margin-bottom: 1px;
    transform: rotate(45deg);
  }
`;
export const NewOptionButton = styled.button`
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #1B49EA;
  padding: 10px;
  color: #1B49EA;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  &:hover {
    color: #ffffff;
    background-color: #1B49EA;
  }
`;
export const SaveWrapDiv = styled.div`
  border-top: 1px solid #ECECEC;
  padding: 30px 30px 45px 30px;
  display: flex;
`;
export const SaveButton = styled.button`
  width: 177px;
  height: 56px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: #1B49EA;
  margin-right: 26px;
`;
export const DraftButton = styled.button`
  width: 177px;
  height: 56px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1B49EA;
  background-color: #edf0fe;
  text-decoration: none;
`;
export const TestSwitchDiv = styled.div`
  display: flex;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  margin: 0px 30px 16px 30px;
`;
export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  margin-right: 10px;
  & input {
    opacity: 0;
    width: 0;
    height: 0;
    &:checked ~ span {
      background-color: #21C17A;
    }
    &:checked ~ span:before {
      -webkit-transform: translateX(15px);
      -ms-transform: translateX(15px);
      transform: translateX(15px);
    }
    &:focus ~ span{
      box-shadow: 0 0 1px #21C17A;
    }
  }
  & span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #C4C6CB;
    -webkit-transition: .2s;
    transition: .2s;
    border-radius: 34px;
    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 4px;
      bottom: 3px;
      background-color: white;
      -webkit-transition: .2s;
      transition: .2s;
      border-radius: 50%;
    }
  }
`;
export const NoQuestionDiv = styled.div`
  width: 600px;
  height: 48px;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #FF2C91;
  color: #FF2C91;
  border-radius: 6px;
`;
